var newsCategory = "";
var newsOrder = "";
var newsField = "";
var callsCategory = "";
var callsOrder = "";
var callsField = "";
var jobsCategory = "";
var jobsOrder = "";
var jobsField = "";
var newsExcludePosts = "";
jQuery(document).ready(function ($) {

    $(window).scroll(function () {
        var sticky = $('.site-header'),
            scroll = $(window).scrollTop();
            if (jQuery("body.home").length > 0) {
                if (scroll >= 100) sticky.addClass('sticky');
                else sticky.removeClass('sticky');
            } else {
                if (scroll >= 5) sticky.addClass('sticky');
                else sticky.removeClass('sticky');
            }

        if (jQuery("body.home").length > 0) {
            if (scroll >= 10) sticky.addClass('scroll_top');
            else sticky.removeClass('scroll_top');

            if (scroll >= 300) sticky.addClass('scroll');
            else sticky.removeClass('scroll');

            if (scroll >= (jQuery(".hero_banner_sec ").height() * 1.1)) sticky.addClass('sticky_home_header');
            else sticky.removeClass('sticky_home_header');

            if (scroll >= 100) jQuery(".hero_banner_sec_content_inner>.banner_heading .banner_heading, .hero_banner_sec_content_inner .banner_content_cta").addClass('hide_text');
            else jQuery(".hero_banner_sec_content_inner>.banner_heading .banner_heading, .hero_banner_sec_content_inner .banner_content_cta").removeClass('hide_text');

            if (jQuery("#featured_news_and_news_grid_2").length > 0) {
                if ((scroll + (jQuery(window).height() * 0.5)) > jQuery("#featured_news_and_news_grid_2").offset().top) jQuery(".feature_news_section_with_grid_inner .heading .feature_head").addClass("show_text");
                else jQuery(".feature_news_section_with_grid_inner .heading .feature_head").removeClass("show_text");
            }

            if (jQuery(".full_width_slider_section .site_container").length > 0) {
                if (jQuery(window).width() > 767 && (scroll + (jQuery(window).height() * 0.75)) > jQuery(".full_width_slider_section .site_container").offset().top) {
                    var multiplier = 1;
                    var deductMore = 100;
                    var dedmultiple = -1;
                    var moveUp = (jQuery(".full_width_slider").offset().top - jQuery(window).scrollTop() + (deductMore * dedmultiple)) * multiplier;
                    if (moveUp < 0) {
                        jQuery(".full_width_slider_section .site_container").css("transform", "translateY(" + moveUp + "px)")
                    }
                } else if (jQuery(window).width() < 768 && scroll > jQuery(".full_width_slider_section").offset().top) {
                    var multiplier = 4;
                    var deductMore = 120;
                    var dedmultiple = 1;
                    var moveUp = (jQuery(".full_width_slider").offset().top - jQuery(window).scrollTop() + (deductMore * dedmultiple)) * multiplier;
                    if (moveUp < 0) {
                        jQuery(".full_width_slider_section .site_container").css("transform", "translateY(" + moveUp + "px)")
                    }
                } else {
                    jQuery(".full_width_slider_section .site_container").removeAttr("style");
                }
            }
        }

    });

    $(".site-header-search-toggle-open").click(function () {
        $(this).attr("aria-expanded", "true");
        $('.site-header').addClass("search_active");
        $('body').addClass("toggle_search_active");
        if ($('body').hasClass("toggle_menu_active")) {
            $('.site-header').removeClass("menu_active");
            $('body').removeClass("toggle_menu_active");
        }
    });

    $(".site-header-search-toggle-close").click(function () {
        $(this).attr("aria-expanded", "false");
        $(".site-header-search-toggle-open").attr("aria-expanded", "false");
        $('.site-header').removeClass("search_active");
        $('body').removeClass("toggle_search_active");
    });

    $(".site-navigation-toggle-open").click(function () {
        $('.site-header').addClass("menu_active");
        $('body').addClass("toggle_menu_active");
        if ($('body').hasClass("toggle_search_active")) {
            $('.site-header').removeClass("search_active");
            $('body').removeClass("toggle_search_active");
        }
    });

    $(".site-navigation-toggle-close").click(function () {
        $('.site-header').removeClass("menu_active");
        $('body').removeClass("toggle_menu_active");
        if ($('nav.primary-navigation li.menu-item-has-children').hasClass("open")) {
            $('nav.primary-navigation li.menu-item-has-children button.submenu-toggle').removeClass("active");
            $('nav.primary-navigation li.menu-item-has-children').removeClass("open");
            $('nav.primary-navigation li.menu-item-has-children .sub-menu').slideUp();
        }
    });

    $('nav.primary-navigation').find('li.menu-item-has-children > a').attr("aria-expanded", "false").attr("type", "button");
    $('nav.primary-navigation').find('li.menu-item-has-children > a').after('<div tabindex="-1" class="submenu-toggle"><svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg"><title>submenu toggle</title><path d="M1.5 1L6.5 6L11.5 1" stroke="#DCD0FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>');
    $('body').on('click', 'nav.primary-navigation button.submenu-toggle', function () {
        $(this).parent().siblings().find('button.submenu-toggle').removeClass("active");
        $(this).parent().siblings().find('button.submenu-toggle').parent().find('> .sub-menu').slideUp().parent().removeClass('open');
        $(this).toggleClass('active').parent().find('> .sub-menu').slideToggle().parent().toggleClass('open');
        if ($(this).parent().find(">.sub-menu").is(":hidden")) {
            $('nav.primary-navigation').find('li.menu-item-has-children > a').attr("aria-expanded", "true");
            var item1 = this;
            setTimeout(function(){ 
                jQuery(item1).parent().find('> .sub-menu').addClass("visible")
            }, 500)
        } else {
            $('nav.primary-navigation').find('li.menu-item-has-children > a').attr("aria-expanded", "false");
            $(this).parent().find('> .sub-menu').removeClass("visible")
        }
    });

    $(document).on("click", function () {
        if ($("nav.primary-navigation li.menu-item-has-children > .sub-menu").hasClass("visible")) {
            // $("nav.primary-navigation li.menu-item-has-children button.submenu-toggle").removeClass("active");
            $("nav.primary-navigation li.menu-item-has-children").removeClass('hover');
            $("nav.primary-navigation li.menu-item-has-children .sub-menu").removeClass("visible");
            $('nav.primary-navigation li.menu-item-has-children > a').attr("aria-expanded", "false");
            // $("nav.primary-navigation li.menu-item-has-children .sub-menu").slideUp();
        }
    })

    $('nav.primary-navigation li.menu-item-has-children > a').on("click", function (e) {
        e.preventDefault();
        if ($(this).parent().hasClass("hover")) {
            $(this).attr("aria-expanded", "false");
            $(this).parent().removeClass("hover");
            $(this).parent().find('> .sub-menu').removeClass("visible");
        } else {
            $(this).parent().addClass("hover");
            $(this).attr("aria-expanded", "true");
            var item1 = this;
            setTimeout(function(){ 
                jQuery(item1).parent().find('> .sub-menu').addClass("visible");
            }, 500)
        }
    })

    jQuery(".full_width_slider_section .next_slide_arrow").on("keyup", function (e) {
        if (e.keyCode == 13) {
            jQuery(this).click();
        }
    })

    jQuery(window).on("keyup", function (e) {
        if (e.keyCode == 27) {
            $('nav.primary-navigation li.menu-item-has-children').removeClass("hover");
            $('body').removeClass("toggle_search_active");
            $('body').removeClass("toggle_menu_active");
            $('.site-header').removeClass("menu_active");
            $('nav.primary-navigation li.menu-item-has-children a').attr("aria-expanded", "false");
        }
    })

    var FormInterval = setInterval(function () {
        if (document.readyState == "complete") {
            clearInterval(FormInterval);
            jQuery(".gfield.autocomplete_given_name input").attr("autocomplete", "given-name");
            jQuery(".gfield.autocomplete_family_name input").attr("autocomplete", "family-name");
            jQuery(".gfield.autocomplete_email input").attr("autocomplete", "email");
            jQuery(".gfield.autocomplete_phone input").attr("autocomplete", "tel");
            jQuery(".gfield.autocomplete_only_name input").attr("autocomplete", "name");
        }
    }, 500);

    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery(".gfield.autocomplete_given_name input").attr("autocomplete", "given-name");
        jQuery(".gfield.autocomplete_family_name input").attr("autocomplete", "family-name");
        jQuery(".gfield.autocomplete_email input").attr("autocomplete", "email");
        jQuery(".gfield.autocomplete_phone input").attr("autocomplete", "tel");
        jQuery(".gfield.autocomplete_only_name input").attr("autocomplete", "name");
    });

    // jQuery('select').selectric({
    //     openOnFocus: false,
    //     disableOnMobile: false,
    //     nativeOnMobile: false
    // });  

    jQuery(".validation_message").attr("role", "alert");
    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery(".validation_message").attr("role", "alert");
    });

    if (jQuery(".hero_banner_sec_slider_items").length > 0) {
        jQuery('.hero_banner_sec_slider_items').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 2000,
            fade: true,
            autoplay: true,
            autoplaySpeed: 6000,
            slidesToShow: 1,
            slidesToScroll: 1,
        });

        var heroBannerInterval = setInterval(function () {
            if (document.readyState == "complete") {
                clearInterval(heroBannerInterval);
                jQuery('.hero_banner_sec_slider_items').find(".slick-slide .slide_image, .slick-slide .slide_video").removeClass("start_zoom");
                if (jQuery('.hero_banner_sec_slider_items').find(".slick-current .slide_image").length > 0) {
                    jQuery('.hero_banner_sec_slider_items').find(".slick-current .slide_image").addClass("start_zoom");
                }
                if (jQuery('.hero_banner_sec_slider_items').find(".slick-current .slide_video").length > 0) {
                    jQuery('.hero_banner_sec_slider_items').find(".slick-current .slide_video").addClass("start_zoom");
                }
            }
        }, 400);

        jQuery('.hero_banner_sec_slider_items').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            console.info(currentSlide);
            jQuery('.hero_banner_sec_slider_items').find(".slick-slide .slide_image, .slick-slide .slide_video").removeClass("start_zoom");
            if (jQuery(".hero_banner_sec_slider_items .slick-slide[data-slick-index='" + currentSlide + "'] .slide_image").length > 0) {
                jQuery(".hero_banner_sec_slider_items .slick-slide[data-slick-index='" + currentSlide + "'] .slide_image").addClass("start_zoom");
            }
            if (jQuery(".hero_banner_sec_slider_items .slick-slide[data-slick-index='" + currentSlide + "'] .slide_video").length > 0) {
                jQuery(".hero_banner_sec_slider_items .slick-slide[data-slick-index='" + currentSlide + "'] .slide_video").addClass("start_zoom");
            }
        });
    }

    if (jQuery(".full_width_slider_section .full_width_slider_items").length > 0) {
        jQuery('.full_width_slider_section .full_width_slider_items').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 1000,
            fade: true,
            autoplay: false,
            autoplaySpeed: 6000,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: "",
            nextArrow: jQuery(".full_width_slider_section .slider_content_box .next_slide_arrow"),
            asNavFor: ".full_width_slider_section .slider_content_box_items",
        });
    }

    if (jQuery(".full_width_slider_section .slider_content_box_items").length > 0) {
        jQuery('.full_width_slider_section .slider_content_box_items').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 1000,
            fade: true,
            autoplay: false,
            autoplaySpeed: 6000,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: ".full_width_slider_section .full_width_slider_items",
        });
    }

    $(".full_width_slider_section").hover(
        function () {
            $(this).addClass("slider_hover");
        },
        function () {
            $(this).removeClass("slider_hover");
        }
    );
    $(".next_slide_arrow").hover(
        function () {
            $(this).closest(".full_width_slider_section").addClass("slider_hover");
        }
    );

    if (jQuery(".news_sort_btn.active").length > 0) {
        newsOrder = jQuery(".news_sort_btn.active").attr("data-order");
        newsField = jQuery(".news_sort_btn.active").attr("data-field");
    }

    jQuery(".news_filter_btn").on("click", function () {
        if (jQuery(this).hasClass("active")) {
            newsCategory = "";
            jQuery(this).removeClass("active");
        } else {
            newsCategory = jQuery(this).attr("data-id");
            jQuery(".news_filter_btn").removeClass("active");
            jQuery(this).addClass("active");
        }
        newsPaged = 1
        jQuery("#news_paged").val("1");
        filterNews("filter");
    })

    jQuery(".news_sort_btn").on("click", function () {
        newsOrder = jQuery(this).attr("data-order");
        newsField = jQuery(this).attr("data-field");
        newsPaged = 1;
        jQuery(".news_sort_btn").removeClass("active");
        jQuery(this).addClass("active");
        jQuery("#news_paged").val("1");
        filterNews("filter");
    })
    jQuery(".loadmore_button .btn_load_more").on("click", function () {
        newsPaged = jQuery("#news_paged").val();
        newsPaged = parseInt(newsPaged) + 1;
        jQuery("#news_paged").val(newsPaged);
        filterNews("loadmore");
    })

    jQuery(".calls_filter_btn").on("click", function () {
        jQuery(this).parent().parent().parent().parent().slideUp();
        if (jQuery(this).hasClass("active")) {
            callsCategory = "";
            jQuery(this).removeClass("active");
        } else {
            callsCategory = jQuery(this).attr("data-id");
            jQuery(".calls_filter_btn").removeClass("active");
            jQuery(this).addClass("active");
             
        }
       
        callsPaged = 1
        jQuery("#calls_paged").val("1");
        jQuery(".funding_calls_pagination .prev_arrow").attr("disabled", "").attr("data-slide", 1);
        jQuery(".funding_calls_pagination .next_arrow").attr("data-slide", 2);
        filterFundingCalls("filter");
    })

    jQuery(".calls_sort_btn").on("click", function () {
        jQuery(this).parent().parent().parent().slideUp();
        callsOrder = jQuery(this).attr("data-order");
        callsField = jQuery(this).attr("data-field");
        callsPaged = 1;
        jQuery(".calls_sort_btn").removeClass("active");
        jQuery(this).addClass("active");
        jQuery("#calls_paged").val("1");
        filterFundingCalls("filter");
    })
    jQuery(".funding_calls_pagination .prev_arrow").on("click", function () {
        var currentSlide = jQuery("#calls_paged").val();
        var maxSlide = jQuery("#calls_paged").attr("data-max");
        if (currentSlide <= 1) {
            return false;
        }
        if (currentSlide < maxSlide) {
            jQuery(".funding_calls_pagination .next_arrow").removeAttr("disabled");
        }
        maxSlide = parseInt(maxSlide);
        callsPaged = parseInt(currentSlide) - 1;
        currentSlideText = (callsPaged < 10 ? "0" + callsPaged : callsPaged);
        maxSlideText = (maxSlide < 10 ? "0" + maxSlide : maxSlide);
        if (callsPaged > 1) {
            jQuery(this).removeAttr("disabled");
        } else {
            jQuery(this).attr("disabled", "disabled");
        }
        jQuery("#calls_paged").val(callsPaged);
        jQuery(".funding_calls_pagination .pagination_text").text(currentSlideText + " / " + maxSlideText);
        filterFundingCalls("loadmore");
    })
    jQuery(".funding_calls_pagination .next_arrow").on("click", function () {
        var currentSlide = jQuery("#calls_paged").val();
        var maxSlide = jQuery("#calls_paged").attr("data-max");
        if (currentSlide == maxSlide) {
            return false;
        }
        if (currentSlide > 1) {
            jQuery(".funding_calls_pagination .prev_arrow").removeAttr("disabled");
        }
        maxSlide = parseInt(maxSlide);
        callsPaged = parseInt(currentSlide) + 1;
        currentSlideText = (callsPaged < 10 ? "0" + callsPaged : callsPaged);
        maxSlideText = (maxSlide < 10 ? "0" + maxSlide : maxSlide);
        if (callsPaged < maxSlide) {
            jQuery(this).removeAttr("disabled");
        } else {
            jQuery(this).attr("disabled", "disabled");
        }
        jQuery("#calls_paged").val(callsPaged);
        jQuery(".funding_calls_pagination .pagination_text").text(currentSlideText + " / " + maxSlideText);
        filterFundingCalls("loadmore");
    })

    jQuery(".jobs_filter_btn").on("click", function () {
        if (jQuery(this).hasClass("active")) {
            jobsCategory = "";
            jQuery(this).removeClass("active");
        } else {
            jobsCategory = jQuery(this).attr("data-id");
            jQuery(".jobs_filter_btn").removeClass("active");
            jQuery(this).addClass("active");
        }
        jobsPaged = 1
        jQuery("#jobs_paged").val("1");
        jQuery(".career_jobs_pagination .prev_arrow").attr("disabled", "").attr("data-slide", 1);
        jQuery(".career_jobs_pagination .next_arrow").attr("data-slide", 2);
        filterJobs("filter");
    })

    jQuery(".jobs_sort_btn").on("click", function () {
        jobsOrder = jQuery(this).attr("data-order");
        jobsField = jQuery(this).attr("data-field");
        jobsPaged = 1;
        jQuery(".jobs_sort_btn").removeClass("active");
        jQuery(this).addClass("active");
        jQuery("#jobs_paged").val("1");
        filterJobs("filter");
    })
    jQuery(".career_jobs_pagination .prev_arrow").on("click", function () {
        var currentSlide = jQuery("#jobs_paged").val();
        var maxSlide = jQuery("#jobs_paged").attr("data-max");
        if (currentSlide <= 1) {
            return false;
        }
        if (currentSlide < maxSlide) {
            jQuery(".career_jobs_pagination .next_arrow").removeAttr("disabled");
        }
        maxSlide = parseInt(maxSlide);
        jobsPaged = parseInt(currentSlide) - 1;
        currentSlideText = (jobsPaged < 10 ? "0" + jobsPaged : jobsPaged);
        maxSlideText = (maxSlide < 10 ? "0" + maxSlide : maxSlide);
        if (jobsPaged > 1) {
            jQuery(this).removeAttr("disabled");
        } else {
            jQuery(this).attr("disabled", "disabled");
        }
        jQuery("#jobs_paged").val(jobsPaged);
        jQuery(".career_jobs_pagination .pagination_text").text(currentSlideText + " / " + maxSlideText);
        filterJobs("loadmore");
    })
    jQuery(".career_jobs_pagination .next_arrow").on("click", function () {
        var currentSlide = jQuery("#jobs_paged").val();
        var maxSlide = jQuery("#jobs_paged").attr("data-max");
        if (currentSlide == maxSlide) {
            return false;
        }
        if (currentSlide > 1) {
            jQuery(".career_jobs_pagination .prev_arrow").removeAttr("disabled");
        }
        maxSlide = parseInt(maxSlide);
        jobsPaged = parseInt(currentSlide) + 1;
        currentSlideText = (jobsPaged < 10 ? "0" + jobsPaged : jobsPaged);
        maxSlideText = (maxSlide < 10 ? "0" + maxSlide : maxSlide);
        if (jobsPaged < maxSlide) {
            jQuery(this).removeAttr("disabled");
        } else {
            jQuery(this).attr("disabled", "disabled");
        }
        jQuery("#jobs_paged").val(jobsPaged);
        jQuery(".career_jobs_pagination .pagination_text").text(currentSlideText + " / " + maxSlideText);
        filterJobs("loadmore");
    })

    jQuery(".faq_list_items .faq_list_items_item_heading").on("click", function () {
        if (jQuery(this).next().is(":hidden")) {
            jQuery(".faq_list_items .faq_list_items_item").removeClass("active");
            jQuery(".faq_list_items .faq_list_items_item_content").slideUp();
            jQuery(this).parent().addClass("active");
            jQuery(this).next().slideDown();
            jQuery(".faq_list_items .faq_list_items_item_heading").attr("aria-expanded", "false");
            jQuery(this).attr("aria-expanded", "true");
        } else {
            jQuery(this).parent().removeClass("active");
            jQuery(this).next().slideUp();
            jQuery(this).attr("aria-expanded", "false");
        }
    })

    $(".filter_button").click(function () {
        $(".category_list").fadeToggle();
        $(".category_list").parent().toggleClass("active");
        var fBtn = this;
        setTimeout(function() {
            if ($(".category_list").is(":visible")) {
                $(fBtn).attr("aria-expanded", "true");
            } else {
                $(fBtn).attr("aria-expanded", "false");
            }
        },500);
    });

    $(".filter_by .category_list .news_filter_btn").click(function(){
        $(".category_list").slideUp();
    });

   

    $(".sort_button").click(function () {
        $(".sort_by_list").fadeToggle();
        var fBtn = this;
        setTimeout(function() {
            if ($(".sort_by_list").is(":visible")) {
                $(fBtn).attr("aria-expanded", "true");
            } else {
                $(fBtn).attr("aria-expanded", "false");
            }
        },500);
    });

    $(".sort_by .sort_by_list .news_sort_btn").click(function(){
        $(".sort_by_list").slideUp();
    });

    if (jQuery(".slider_controls_btn").length > 0) {
        jQuery(".slider_controls_btn").on("click", function () {
            if (jQuery(this).hasClass("slider_pause")) {
                jQuery(this).attr("aria-label", "pause");
                jQuery(this).removeClass("slider_pause");
                jQuery(".hero_banner_sec_slider_items").removeClass("disable_zoom");
                jQuery(".hero_banner_sec_slider_items").slick("slickSetOption", "autoplay", true, true);
            } else {
                jQuery(this).attr("aria-label", "play");
                jQuery(this).addClass("slider_pause");
                jQuery(".hero_banner_sec_slider_items").addClass("disable_zoom");
                jQuery(".hero_banner_sec_slider_items").slick("slickSetOption", "autoplay", false, true);
            }
        })
    }

    jQuery(document).on("click", ".site-header .site-nav-main #primary-menu-list>.menu-item-has-children", function (e) {
        // e.preventDefault();
        if (jQuery(window).width() < 1200) {
            if (jQuery(this).find(".sub-menu").is(":hidden")) {
                jQuery(this).find(".sub-menu").slideDown();
            } else {
                jQuery(this).find(".sub-menu").slideUp();
            }
            // jQuery(this).next().trigger("click");
            //return false;
        }
    })

    // if (jQuery("body.home").length > 0) {
    //     jQuery(".hero_banner_sec_content_inner .h1.banner_heading").css("height", jQuery(".hero_banner_sec_content_inner > .banner_heading").outerHeight());
    // }
})

// jQuery(window).on("resize", function() {
//     if (jQuery("body.home").length > 0) {
//         jQuery(".hero_banner_sec_content_inner .h1.banner_heading").css("height", jQuery(".hero_banner_sec_content_inner > .banner_heading").outerHeight());
//     }
// })

function filterNews(type) {
    var admin_url = jQuery("#ajax_url").val();
    var perpage = jQuery("#news_per_page").val();
    var newsPaged = jQuery("#news_paged").val();
    var newsExcludePosts = jQuery("#news_exclude_posts").val();

    var currentPostCount = jQuery(".news_list_items_with_loadmore > .news_list_items > .item").length;

    jsonObj = {
        "action": "news_filter",
        "category": newsCategory,
        "sortbyorder": newsOrder,
        "sortby": newsField,
        "postperpage": parseInt(perpage),
        "currentPostCount": currentPostCount,
        "paged": newsPaged,
        "exclude_posts": newsExcludePosts,
        "type": type
    };

    jQuery.ajax({
        url: admin_url,
        data: jsonObj, // form data
        type: "POST", // POST
        async: true,
        beforeSend: function (xhr) {
            console.log("ajax start"); // changing the button label
        },
        success: function (data) {
            // console.log(data.data);

            if (data.data.replace(/(\r\n\t|\n|\r\t)/gm, "").replace(" ", "") == "false" && type != 'loadmore') {
                // jQuery('.load_more_img').hide();
                jQuery(".news_list_items_with_loadmore > .news_list_items").html("<div class='no_found'>Result not found!!</div>");
                jQuery(".news_list_items_with_loadmore > .news_list_items").show();
                jQuery(".loadmore_button").hide();
                return false;
            } else if (type == 'loadmore') {
                // jQuery('.load_more_img').hide();
                jQuery(".news_list_items_with_loadmore > .news_list_items").show();
                jQuery(".news_list_items_with_loadmore > .news_list_items").append(data.data);
            } else {
                jQuery(".news_list_items_with_loadmore > .news_list_items").html("");
                jQuery(".news_list_items_with_loadmore > .news_list_items").html(data.data);
                // jQuery('.load_more_img').hide();
                jQuery(".news_list_items_with_loadmore > .news_list_items").show();
            }

            setTimeout(function () {
                var total = jQuery("#total_post_count").val();
                var current = jQuery("#current_post_count").val();

                var c_total = jQuery(".news_list_items_with_loadmore > .news_list_items > .item").length;
                if (total != '' && current != '') {
                    if (parseInt(total) == c_total) {
                        jQuery(".loadmore_button").hide();
                    } else {
                        jQuery(".loadmore_button").show();
                    }
                }
                jQuery("#total_post_count").remove();
                jQuery("#current_post_count").remove();
            }, 1000);

        },
        error: function (xhr) {
            jQuery('.load_more_img').hide();
            jQuery(".news_list_items_with_loadmore > .news_list_items").show();
            console.log(xhr);
        }
    });
}

function filterFundingCalls(type) {
    var admin_url = jQuery("#ajax_url").val();
    var perpage = jQuery("#calls_per_page").val();
    var callsPaged = jQuery("#calls_paged").val();

    var currentPostCount = jQuery(".funding_post_list_outer > .funding_post_list_items > .funding_calls_item").length;

    jsonObj = {
        "action": "funding_calls_filter",
        "category": callsCategory,
        "sortbyorder": callsOrder,
        "sortby": callsField,
        "postperpage": parseInt(perpage),
        "currentPostCount": currentPostCount,
        "paged": callsPaged,
        "type": type
    };

    jQuery.ajax({
        url: admin_url,
        data: jsonObj, // form data
        type: "POST", // POST
        async: true,
        beforeSend: function (xhr) {
            console.log("ajax start"); // changing the button label
        },
        success: function (data) {
            // console.log(data.data);

            if (data.data.replace(/(\r\n\t|\n|\r\t)/gm, "").replace(" ", "") == "false" && type != 'loadmore') {
                // jQuery('.load_more_img').hide();
                jQuery(".funding_post_list_outer > .funding_post_list_items").html("<div class='no_found'>Result not found!!</div>");
                jQuery(".funding_post_list_outer > .funding_post_list_items").show();
                jQuery(".loadmore_button").hide();
                return false;
            } else {
                jQuery(".funding_post_list_outer > .funding_post_list_items").html(data.data);
                jQuery(".funding_post_list_outer > .funding_post_list_items").show();
            }

            setTimeout(function () {
                var total = jQuery("#total_post_count").val();
                var current = jQuery("#current_post_count").val();

                var c_total = jQuery(".funding_post_list_outer > .funding_post_list_items > .funding_calls_item").length;
                if (total != '' && current != '') {
                    if (parseInt(total) == c_total) {
                        jQuery(".loadmore_button").hide();
                    } else {
                        jQuery(".loadmore_button").show();
                    }
                }
                var currentSlide = jQuery("#calls_paged").val();
                var maxSlide = jQuery("#calls_paged").attr("data-max");
                currentSlide = parseInt(currentSlide);
                maxSlide = parseInt(maxSlide);
                if (currentSlide < maxSlide) {
                    jQuery(".funding_calls_pagination .next_arrow").removeAttr("disabled");
                }
                if (currentSlide > 1) {
                    jQuery(".funding_calls_pagination .prev_arrow").removeAttr("disabled");
                }
                if (type == "filter") {
                    jQuery("#calls_paged").val(1);
                    currentSlide = 1;
                }
                currentSlideText = (currentSlide < 10 ? "0" + currentSlide : currentSlide);
                maxSlideText = (maxSlide < 10 ? "0" + maxSlide : maxSlide);
                jQuery(".funding_calls_pagination .pagination_text").text(currentSlideText + " / " + maxSlideText);
                jQuery("#total_post_count").remove();
                jQuery("#current_post_count").remove();
            }, 1000);

        },
        error: function (xhr) {
            jQuery('.load_more_img').hide();
            jQuery(".funding_post_list_outer > .funding_post_list_items").show();
            console.log(xhr);
        }
    });
}

function filterJobs(type) {
    var admin_url = jQuery("#ajax_url").val();
    var perpage = jQuery("#jobs_per_page").val();
    var jobsPaged = jQuery("#jobs_paged").val();

    var currentPostCount = jQuery(".jobs_post_list_outer > .jobs_post_list_items > .career_jobs_item").length;

    jsonObj = {
        "action": "job_filter",
        "category": jobsCategory,
        "sortbyorder": jobsOrder,
        "sortby": jobsField,
        "postperpage": parseInt(perpage),
        "currentPostCount": currentPostCount,
        "paged": jobsPaged,
        "type": type
    };

    jQuery.ajax({
        url: admin_url,
        data: jsonObj, // form data
        type: "POST", // POST
        async: true,
        beforeSend: function (xhr) {
            console.log("ajax start"); // changing the button label
        },
        success: function (data) {
            // console.log(data.data);

            if (data.data.replace(/(\r\n\t|\n|\r\t)/gm, "").replace(" ", "") == "false" && type != 'loadmore') {
                // jQuery('.load_more_img').hide();
                jQuery(".jobs_post_list_outer > .jobs_post_list_items").html("<div class='no_found'>Result not found!!</div>");
                jQuery(".jobs_post_list_outer > .jobs_post_list_items").show();
                jQuery(".loadmore_button").hide();
                return false;
            } else {
                jQuery(".jobs_post_list_outer > .jobs_post_list_items").html(data.data);
                jQuery(".jobs_post_list_outer > .jobs_post_list_items").show();
            }

            setTimeout(function () {
                var total = jQuery("#total_post_count").val();
                var current = jQuery("#current_post_count").val();

                var c_total = jQuery(".jobs_post_list_outer > .jobs_post_list_items > .career_jobs_item").length;
                if (total != '' && current != '') {
                    if (parseInt(total) == c_total) {
                        jQuery(".loadmore_button").hide();
                    } else {
                        jQuery(".loadmore_button").show();
                    }
                }
                var currentSlide = jQuery("#jobs_paged").val();
                var maxSlide = jQuery("#jobs_paged").attr("data-max");
                currentSlide = parseInt(currentSlide);
                maxSlide = parseInt(maxSlide);
                if (currentSlide < maxSlide) {
                    jQuery(".career_jobs_pagination .next_arrow").removeAttr("disabled");
                }
                if (currentSlide > 1) {
                    jQuery(".career_jobs_pagination .prev_arrow").removeAttr("disabled");
                }
                if (type == "filter") {
                    jQuery("#jobs_paged").val(1);
                    currentSlide = 1;
                }
                currentSlideText = (currentSlide < 10 ? "0" + currentSlide : currentSlide);
                maxSlideText = (maxSlide < 10 ? "0" + maxSlide : maxSlide);
                jQuery(".career_jobs_pagination .pagination_text").text(currentSlideText + " / " + maxSlideText);
                jQuery("#total_post_count").remove();
                jQuery("#current_post_count").remove();
            }, 1000);

        },
        error: function (xhr) {
            jQuery('.load_more_img').hide();
            jQuery(".funding_post_list_outer > .funding_post_list_items").show();
            console.log(xhr);
        }
    });
}